import { LOGO_DOMAIN } from '@/constants';
import { ISpace } from '@/types';

export default function getTypedreamSubdomain(space: ISpace) {
  if (!space) return null;
  const { slug } = space;
  return process.env.NODE_ENV !== 'development' && !LOGO_DOMAIN.includes('vercel.app')
    ? `${slug}.${LOGO_DOMAIN}`
    : `${LOGO_DOMAIN}/${slug}`;
}
